import { render, staticRenderFns } from "./plan_detail.vue?vue&type=template&id=c836d1ce&scoped=true"
import script from "./plan_detail.vue?vue&type=script&lang=js"
export * from "./plan_detail.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c836d1ce",
  null
  
)

export default component.exports